export const predefinedPromptsForPlayer = [
  "How does {playerName}'s kill/death ratio compare to other players?",
  "What strategies does {playerName} use when playing Reyna?",
  "How effective is {playerName}'s clutch success rate?",
  "What is {playerName}'s average damage per round?",
  "Which agents does {playerName} perform best with?",
  "What is the significance of {playerName}'s first kills per round?",
  "How does {playerName} maintain a high survival/trade rate?",
  "Can you analyze {playerName}'s overall rating and combat score?"
];
